export enum CookieName {
  SELECTED_COMPANY = 'selectedCompany',
  SIDENAV_CONFIG = 'sidenavConfig'
}
